import { useCallback } from 'react';
import { useUser } from 'contexts';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLastReceiveDaybook } from '../redux/actions/receiveInventory';
import moment from 'moment';
import { getFinancialYears } from '../redux/actions/dashboard';

const useReceiveLastDaybook = () => {
   const [selectedDaybookId, setSelectedDaybookId] = useState(null);
   const { user } = useUser();
   const dispatch = useDispatch();
   const lastDaybook = useSelector((state) => state.receiveInventory?.lastReceiveDaybook);
   const financialYears = useSelector((state) => state?.dashboard?.financialYears);
   const financialYear = financialYears?.find((a) => a.financial_year === user?.financialYear);

   const getLastDaybook = useCallback(async () => {
      if (user && user?.loginhistory?.companyId && financialYear?.financial_year) {
         await dispatch(getFinancialYears({ companyId: user?.loginhistory?.companyId }));
         const fromDate = moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
         const toDate = moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD');

         const params = {
            companyId: user.loginhistory.companyId,
            fromDate,
            toDate,
            ...(selectedDaybookId && { daybookId: selectedDaybookId }),
         };
         await dispatch(getLastReceiveDaybook(params));
      }
   }, [dispatch, selectedDaybookId, user]);

   useEffect(() => {
      getLastDaybook();
   }, [getLastDaybook]);

   return { lastDaybook, setSelectedDaybookId };
};

export default useReceiveLastDaybook;
